var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.ua.isFromPc())?_c('button',{staticClass:"button-share",class:{'-white': _vm.isWhite},on:{"click":_vm.share}},[_c('span',{staticClass:"icon icon-share"})]):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }